import React, {useState} from "react";
import "./App.css";
import {getFilteredStations, NowPlaying, StationList, STATIONS, updateMediaSessionMetadata} from "./features";
import useNowPlaying from "./hooks/useNowPlaying";
import useMediaSession from "./hooks/useMediaSession";
import useTheme from "./hooks/useTheme";
import useSaveLastStation from "./hooks/useSaveLastStation";
import {Header} from "./components";

function App() {
  const [currentStation, setCurrentStation] = useState(() => {
    const lastId = localStorage.getItem("lastStationId");
    if (lastId) {
      const found = STATIONS.find((s) => String(s.id) === lastId);
      if (found) return found;
    }
    return STATIONS[0] || null;
  });
  const [search, setSearch] = useState("");
  const [theme, setTheme] = useState("light");
  const [nowPlaying, setNowPlaying] = useState({});
  const currentNowPlaying = currentStation ? nowPlaying[currentStation.id] || '' : '';
  const [isPlaying, setIsPlaying] = useState(false);

  useTheme(setTheme);
  useNowPlaying(STATIONS, setNowPlaying, 20000, currentStation);
  useSaveLastStation(currentStation);
  useMediaSession(isPlaying, currentStation, currentNowPlaying, updateMediaSessionMetadata);

  const filteredStations = getFilteredStations(STATIONS, search);

  return (
      <div className="app-root">
        <div className="app-shell">
          <Header theme={theme}/>
          <main className="app-main">
            <StationList search={search} setSearch={setSearch} currentStation={currentStation}
                         filteredStations={filteredStations} isPlaying={isPlaying} setCurrentStation={setCurrentStation}
                         STATIONS={STATIONS}/>
            <NowPlaying currentStation={currentStation} isPlaying={isPlaying} setIsPlaying={setIsPlaying}
                        nowPlayingStatus={currentNowPlaying ? 'ready' : 'idle'} nowPlayingTrack={currentNowPlaying}/>
          </main>
        </div>
      </div>
  );
}

export default App;


